module.exports = __webpack_public_path__ + "img/app_burning_civilization_1.239fa99f.jpg";